"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripParentheses = exports.hasSkusInStockForColour = exports.hasOptions = exports.getSwatchImage = exports.getSizesForColour = exports.getProductSize = exports.getFirstAvailableSku = exports.getDefaultColour = exports.getColourIsOutOfStock = exports.findSkuBy = exports.filterSkusBy = exports.determineSelectedSku = exports.determineOutOfStock = exports.combineNameWithColour = exports.allSkusOutOfStock = void 0;
var _imageUrlModifier = require("../../../utils/imageUrlModifier/imageUrlModifier");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var filterSkusBy = exports.filterSkusBy = function filterSkusBy(options, _ref) {
  var skus = _ref.skus;
  return skus.filter(function (sku) {
    return Object.entries(options).every(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        option = _ref3[0],
        value = _ref3[1];
      return sku[option] === value;
    });
  });
};
var hasOptions = exports.hasOptions = function hasOptions(state, options) {
  return !!state[options] && state[options].length > 0;
};
var findSkuBy = exports.findSkuBy = function findSkuBy(options, _ref4) {
  var skus = _ref4.skus;
  return skus.find(function (sku) {
    return Object.entries(options).every(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        option = _ref6[0],
        value = _ref6[1];
      return sku[option] === value;
    });
  });
};
var stripParentheses = exports.stripParentheses = function stripParentheses() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return count ? count.toString().replace(/\(|\)/g, '') : '';
};
var getProductSize = exports.getProductSize = function getProductSize(defaultColour, sizes) {
  return !defaultColour && sizes && sizes.length === 1 ? sizes[0] : undefined;
};
var getSizesForColour = exports.getSizesForColour = function getSizesForColour(colour, product) {
  return filterSkusBy({
    colour: colour
  }, product).map(function (sku) {
    return sku.size;
  });
};
var allSkusOutOfStock = exports.allSkusOutOfStock = function allSkusOutOfStock(skus) {
  return skus.reduce(function (total, _ref7) {
    var stockLevel = _ref7.stockLevel,
      availableToOrder = _ref7.availableToOrder;
    // for performance reasons PLP only get stockLevel for the selected colour
    // and use ProdCat availableToOrder (boolean) for the skus for other colours
    // until they are selected
    var stockAvailable = availableToOrder ? 1 : 0;
    var stockFigure = stockLevel >= 0 ? stockLevel : stockAvailable;
    return total + stockFigure;
  }, 0) === 0;
};
var hasSkusInStockForColour = exports.hasSkusInStockForColour = function hasSkusInStockForColour(colour, skus) {
  return !allSkusOutOfStock(filterSkusBy({
    colour: colour
  }, {
    skus: skus
  }));
};
var getColourIsOutOfStock = exports.getColourIsOutOfStock = function getColourIsOutOfStock(colours, selectedColour) {
  var _colours$find;
  return selectedColour && !((_colours$find = colours.find(function (_ref8) {
    var colour = _ref8.colour;
    return colour === selectedColour;
  })) !== null && _colours$find !== void 0 && _colours$find.inStock);
};
var getFirstAvailableSku = exports.getFirstAvailableSku = function getFirstAvailableSku(skus) {
  return skus.skus.find(function (sku) {
    return sku.stockLevel > 0 || sku.stockLevel === undefined && sku.availableToOrder;
  });
};
var getDefaultColour = exports.getDefaultColour = function getDefaultColour(_ref9, order) {
  var _sku, _sku2, _sku3;
  var skus = _ref9.skus,
    defaultSku = _ref9.defaultSku;
  var sku = findSkuBy({
    id: defaultSku
  }, {
    skus: skus
  });
  if ((_sku = sku) !== null && _sku !== void 0 && _sku.stockLevel && sku.stockLevel === 0 || !((_sku2 = sku) !== null && _sku2 !== void 0 && _sku2.stockLevel) && !((_sku3 = sku) !== null && _sku3 !== void 0 && _sku3.availableToOrder)) {
    sku = getFirstAvailableSku({
      skus: skus
    });
  }
  if (order) {
    sku = findSkuBy({
      colour: order[0]
    }, {
      skus: skus
    });
  }
  return sku ? sku.colour : undefined;
};
var getSwatchImage = exports.getSwatchImage = function getSwatchImage(colour, _ref0) {
  var swatches = _ref0.swatches;
  var swatch = swatches.find(function (_ref1) {
    var label = _ref1.label;
    return label === colour;
  });
  return swatch ? (0, _imageUrlModifier.modifyImageUrlQueryParams)(swatch.imageSrc, {
    sm: 'c'
  }) : undefined;
};
var determineOutOfStock = exports.determineOutOfStock = function determineOutOfStock(skus, colours, hasColourOptions, shouldSelectSize, selectedSku, selectedColour) {
  if (shouldSelectSize) {
    return !!(hasColourOptions ? getColourIsOutOfStock(colours, selectedColour) : allSkusOutOfStock(skus));
  }
  return !!selectedSku && selectedSku.stockLevel === 0;
};
var determineSelectedSku = exports.determineSelectedSku = function determineSelectedSku(product, hasSizeOptions, hasColourOptions, selectedSize, selectedColour) {
  var selectedSku;
  var skus = product.skus || [];
  var defaultSku = product.defaultSku || {};
  if (hasSizeOptions && !hasColourOptions) {
    selectedSku = findSkuBy({
      size: selectedSize
    }, product);
  } else if (!hasSizeOptions && hasColourOptions || hasSizeOptions && hasColourOptions && !selectedSize) {
    selectedSku = findSkuBy({
      colour: selectedColour
    }, product);
  } else if (hasSizeOptions && hasColourOptions) {
    selectedSku = findSkuBy({
      size: selectedSize,
      colour: selectedColour
    }, product);
  } else if (!hasSizeOptions && !hasColourOptions) {
    // selectedSku = defaultSku;
  }

  // No criteria to select a sku so use the defaultSku (or first sku if they forgot to set a default sku)
  return selectedSku || skus.find(function (sku) {
    return sku.id === defaultSku;
  }) || skus[0];
};
var combineNameWithColour = exports.combineNameWithColour = function combineNameWithColour(name, colour) {
  return "".concat(name, ", ").concat(colour);
};